// name: leafletPolygon
const state = {
  polygonStyle: {
    color:'rgba(0, 158, 177, 1)'
  },
  customMarkerTypeProp: 'markerType',
  customTextProp: 'customText',
  customTextColorProp: 'customTextColor',
};
const getters = {
  polygonStyle: (state)=>{ return state.polygonStyle; },
  customMarkerTypeProp: (state)=>{ return state.customMarkerTypeProp; },
  customTextProp: (state)=>{ return state.customTextProp; },
  customTextColorProp: (state)=>{ return state.customTextColorProp; },
};
const mutations = {

};
const actions = {
  
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
